module.exports = __webpack_public_path__ + "img/5.8e3e5f48.jpg";